import React from 'react';
import { ChevronRight } from 'lucide-react';

const Footer = () => {
  const demoLink = "https://calendly.com/avishkar-easemytkt/30min";

  return (
    <footer className="site-footer">
      <div className="container">
        <div className="final-cta section-padding">
          <div className="cta-content">
            <h2>Transform IT Support into Autonomous IT Operations</h2>
            <p>Designed for enterprises that demand reliability, intelligence, and scale.</p>
            <a href={demoLink} className="btn btn-primary btn-lg">
              Schedule Enterprise Demo <ChevronRight size={20} />
            </a>
          </div>
        </div>

        <div className="footer-bottom">
          <div className="footer-brand">
            <div className="logo-text">Raptic<span className="logo-accent">91</span><sup>™</sup></div>
            <p className="footer-tagline">The AI Layer for Autonomous IT Ops.</p>
          </div>

          <div className="footer-links">
            <div className="link-group">
              <h4>Product</h4>
              <a href="#">AI Core</a>
              <a href="#">Ops Engine</a>
              <a href="#">Integrations</a>
              <a href="#">Roadmap</a>
            </div>
            <div className="link-group">
              <h4>Company</h4>
              <a href="#">About Us</a>
              <a href="#">Careers</a>
              <a href="#">Contact</a>
              <a href="#">Partners</a>
            </div>
            <div className="link-group">
              <h4>Resources</h4>
              <a href="#">Case Studies</a>
              <a href="#">Architecture</a>
              <a href="#">Docs</a>
              <a href="#">Support</a>
            </div>
          </div>
        </div>

        <div className="footer-legal">
          <div className="copyright">© 2026 Raptic91<sup>™</sup>. A product of Blackshift Technologies LLP. All rights reserved.</div>
          <div className="legal-links">
            <a href="#">Privacy Policy</a>
            <a href="#">Terms of Service</a>
            <a href="#">Cookie Policy</a>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
